var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-organization_3_",
    "data-name": "icons8-organization (3)",
    d: "M3.6,3A1.7,1.7,0,0,0,2,4.778V19H18V8.333a1.709,1.709,0,0,0-1.6-1.778H13.2V4.778A1.7,1.7,0,0,0,11.6,3ZM5.2,6.556H6.8V8.333H5.2Zm3.2,0H10V8.333H8.4Zm4.8,1.778h3.2v8.889H13.2V15.444h1.6V13.667H13.2V11.889h1.6V10.111H13.2Zm-8,1.778H6.8v1.778H5.2Zm3.2,0H10v1.778H8.4ZM5.2,13.667H6.8v1.778H5.2ZM3.6,4.778h8V17.222h-8Z",
    transform: "translate(-2 -3)",
    fill: "#2a60bc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.e4ce71c61e466823b808074795806765.svg";
export { ForwardRef as ReactComponent };